import Box from '@mui/material/Box'
import { useTranslation } from 'react-i18next'
import { Form } from '@carsys/form'
import { BaseStepLayout } from '../BaseStepLayout'
import { StepNavigation } from '../StepNavigation'
import { defaultStepFormProps } from '../types.d'
import { FormResult, FormValues } from './types.d'
import { ChangeTyreFields } from 'app/settings/components/TyreChange/ChangeTyreFields'
import { useQuery } from '@tanstack/react-query'
import { useDispatch } from 'react-redux'
import { loadWorkorderActivitiesList } from 'app/settings/state/WorkorderActivities/actions'
import { WithRunInBackgroundHelper } from '../use-should-run-in-background'

const nonEmptyValues = (input: object): object => {
  const entriesWithActualValues = Object.entries(input).filter(([_, value]) => !!value)
  return Object.fromEntries(entriesWithActualValues)
}
interface ChangeTyreForm {
  onSubmit: (values: any) => any
}

export const ChangeTyreForm: React.FC<defaultStepFormProps & ChangeTyreForm> = ({
  onSubmit,
  prevStep,
  isFirstStep,
  isPersisting,
  onSubmitSuccess,
  hideSkip,
  shouldRunInBackground,
  initialData
}) => {
  const { t } = useTranslation()
  const dispatch = useDispatch()

  const { data, isLoading } = useQuery(['GET_WORK_ORDER_ACTIVITIES'], async () => {
    const { Data } = await dispatch(
      loadWorkorderActivitiesList({
        fields: 'Activity.UUID,Activity.Description'
      })
    )

    return Data
  })

  const initialValues = {
    SummerMinThreshold: 3,
    UseSummerThreshold: true,
    WinterMinThreshold: 3,
    UseWinterThreshold: true,
    SummerChangeWarningMonths: [],
    UseSummerChangeWarning: true,
    WinterChangeWarningMonths: [],
    UseWinterChangeWarning: true,
    ...nonEmptyValues(initialData)
  }

  if (isLoading || !data) return null

  return (
    <BaseStepLayout title={t('onboarding.tyre_change.step_header')} subTitles={[t('onboarding.tyre_change.step_info')]}>
      <Form<FormValues, FormResult>
        onSubmit={onSubmit}
        onSubmitSuccess={onSubmitSuccess}
        initialValues={initialValues}
        NavigationConfirmation={null}
        enableReinitialize
      >
        {({ isSubmitting, handleSubmit }) => (
          <WithRunInBackgroundHelper enabled={shouldRunInBackground} isSubmitting={isSubmitting} onSubmit={handleSubmit}>
            <Box>
              <ChangeTyreFields activityOptions={data} />
            </Box>
            <StepNavigation prevStep={prevStep} hideBack={isFirstStep} isLoading={isSubmitting || isPersisting} hideSkip={hideSkip} />
          </WithRunInBackgroundHelper>
        )}
      </Form>
    </BaseStepLayout>
  )
}
